import { FC, useMemo } from 'react';

import dayjs from 'dayjs';
import useSWR from 'swr';

import { CampaignActionsColumn } from './campaignActionsColumn/CampaignActionsColumn';

import css from './MailingCampaigns.module.css';

import { mailingService } from 'v2/api/mailingService';
import { DataTable } from 'v2/components/dataTable/DataTable';
import { usePagination } from 'v2/hooks/usePagination';
import { TableColumn } from 'v2/types';
import { MailingCampaign } from 'v2/types/MailingModel';

export const MailingCampaigns: FC = () => {
  const pagination = usePagination();

  const { data, mutate } = useSWR(
    ['getMailingCampaigns', pagination.page, pagination.pageSize],
    mailingService.getCampaigns,
    { keepPreviousData: true, refreshInterval: 30000 }
  );

  const columns: TableColumn<MailingCampaign>[] = useMemo(
    () => [
      {
        key: 'status',
        label: 'Status',
        render: (row) => <span className={`${css.statusBadge} ${row.status}`}>{row.status}</span>,
      },
      {
        key: 'recipients',
        label: 'Sent / Total',
        render: (row) => `${row.sentCount} / ${row.totalRecipients}`,
      },
      {
        key: 'failed',
        label: 'Failed',
        render: (row) => row.failedCount,
      },
      {
        key: 'createdAt',
        label: 'Created At',
        render: (row) => dayjs(row.createdAt).format('DD.MM.YYYY HH:mm'),
      },
      {
        key: 'actions',
        label: 'Actions',
        render: (row) => <CampaignActionsColumn campaign={row} onRevalidate={mutate} />,
      },
    ],
    [mutate]
  );

  return (
    <div className={css.campaignsContainer}>
      <DataTable
        columns={columns}
        data={data?.result}
        withPagination
        total={data?.total}
        page={pagination.page}
        pageSize={pagination.pageSize}
        onPageChange={pagination.onPageChange}
      />
    </div>
  );
};
